// extracted by mini-css-extract-plugin
module.exports = {"container":"_2LPHv_kJZnhlvmvr24-1MH","restaurantList":"_39tkwRhGF2fP9m7ii2oZh1"};